import React from "react";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import "./LoaderComponent.scss";

const LoaderComponent = ({ isloading, loaderText, children }) => {
  const loaderReducerLoading = useSelector(
    (state) => state.loaderReducer?.loading
  );

  const combinedLoadingState = isloading || loaderReducerLoading;

  return (
    <>
      <Spin
        style={{ zIndex: 1005 }}
        spinning={combinedLoadingState}
        tip={loaderText || "Please wait..."}
        size="large"
        fullscreen
      ></Spin>
      {children}
    </>
  );
};

export default LoaderComponent;
